import { Navbar } from "../components/sections/Navbar";
import { Footer } from "../components/sections/Footer";
import useReveal from "../lib/useReveal";

/**
 * Wraps a single section for standalone routing so it renders with the
 * global Navbar and Footer, gets the reveal animation observer, and adds
 * top padding so the section clears the fixed navbar.
 */
export const StandaloneSection = ({ children }) => {
    useReveal();
    return (
        <main className="min-h-screen bg-white">
            <Navbar />
            <div className="pt-20">{children}</div>
            <Footer />
        </main>
    );
};
